import { Modal, ModalBaseCloseButtonProps, ModalProps } from '@mantine/core'

import CloseIcon from '@/assets/icons/close-small.svg'
import { SectionErrorBoundary } from '@/components/error/boundary'
import { useIsResponsiveMobileView } from '@/hooks/responsive'

import classes from './index.module.css'

interface ResponsiveModalProps extends ModalProps {
  closeButtonProps?: ModalBaseCloseButtonProps
}

export default function ResponsiveModal({
  classNames,
  closeButtonProps,
  children,
  ...remainingProps
}: Readonly<ResponsiveModalProps>) {
  const isMobileView = useIsResponsiveMobileView()

  return (
    <Modal
      fullScreen={isMobileView}
      centered={true}
      transitionProps={isMobileView ? { transition: 'fade', duration: 200 } : undefined}
      classNames={{
        body: classes.responsiveModalBody,
        header: classes.responsiveModalHeader,
        content: classes.responsiveContent,
        ...classNames,
      }}
      closeButtonProps={{
        ...closeButtonProps,
        className: `${closeButtonProps?.className} ${classes.closeButton}`,
        icon: <CloseIcon width={24} height={24} fill="var(--content-secondary)" />,
      }}
      {...remainingProps}
    >
      <SectionErrorBoundary>{children}</SectionErrorBoundary>
    </Modal>
  )
}
